const MainLayout = ({children}) => {
    return (<div>{children}</div>)
};
export default MainLayout;